const BASE_URL = 'https://api.ispdaftar.com/api/v1';
// const BASE_IP = 'localhost';
// const BASE_IP = '113.203.193.251';
// const BASE_URL = `http://${BASE_IP}:5001/api/v1`;

export default {
    tokenType: 'Bearer',

    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken',
    storageUserKeyName: 'user',
    storageIsLoginKeyName: 'isLogin',

    //auth endpoints
    loginEndpoint: `${BASE_URL}/auth/login`,
    refreshEndpoint: `${BASE_URL}/auth/refreshToken`,
    logoutEndpoint: `${BASE_URL}/auth/logout`,
    updatePasswordEndpoint: `${BASE_URL}/auth/update-password`,
    forgotPasswordEndpoint: `${BASE_URL}/auth/forgot-password`,
    resetPasswordEndpoint: `${BASE_URL}/auth/reset-password`,
    signupEndpoint: `${BASE_URL}/auth/signup`,
    verifyEmailEndpoint: `${BASE_URL}/auth/verify-email`,
    resendVerificationEndpoint: `${BASE_URL}/auth/resend-verification`,

    //inquiry endpoint
    inquiryEndpoint: `${BASE_URL}/inquiry/submit`,

    //isp endpoint
    ispEndpoint: `${BASE_URL}/isp`,

    //package endpoint
    packageEndpoint: `${BASE_URL}/package`,

    //staff endpoint
    staffEndpoint: `${BASE_URL}/staff`,
    updateProfileEndpoint: `${BASE_URL}/staff/update-profile`,
    completeOnboardingEndpoint: `${BASE_URL}/staff/complete-onboarding`,

    //user endpoint
    userEndpoint: `${BASE_URL}/user`,

    //user import endpoint
    userImportTemplateEndpoint: `${BASE_URL}/user-import/template`,
    userImportPreviewEndpoint: `${BASE_URL}/user-import/preview`,
    userImportCommitEndpoint: `${BASE_URL}/user-import/commit`,

    //entry import endpoint
    entryImportTemplateEndpoint: `${BASE_URL}/entry-import/template`,
    entryImportPreviewEndpoint: `${BASE_URL}/entry-import/preview`,
    entryImportCommitEndpoint: `${BASE_URL}/entry-import/commit`,

    //entry endpoint
    entryEndpoint: `${BASE_URL}/entry`,

    //invoice endpoint
    invoiceEndpoint: `${BASE_URL}/invoice`,

    //expense endpoint
    expenseEndpoint: `${BASE_URL}/expense`,

    //summary endpoint
    summaryEndpoint: `${BASE_URL}/summary`,

    //extra income endpoint
    extraIncomeEndpoint: `${BASE_URL}/extra-income`,

    //settings endpoint
    settingsEndpoint: `${BASE_URL}/settings`,

    //audit log endpoint
    auditLogEndpoint: `${BASE_URL}/audit-log`,

    //platform admin endpoints
    platformLoginEndpoint: `${BASE_URL}/platform/auth/login`,
    tenantsEndpoint: `${BASE_URL}/platform/tenants`,
    platformStatsEndpoint: `${BASE_URL}/platform/stats`,
    platformRevenueEndpoint: `${BASE_URL}/platform/revenue/monthly`,

    //user (customer) auth endpoints
    userLoginEndpoint: `${BASE_URL}/user-auth/login`,
    userForgotPasswordEndpoint: `${BASE_URL}/user-auth/forgot-password`,
    userResetPasswordEndpoint: `${BASE_URL}/user-auth/reset-password`,

    //customer endpoints
    customerEntriesEndpoint: `${BASE_URL}/customer/entries`,
    customerTenantEndpoint: `${BASE_URL}/customer/tenant`,
    customerProfileEndpoint: `${BASE_URL}/customer/profile`,
    customerUpdateProfileEndpoint: `${BASE_URL}/customer/update-profile`,
    customerUpdatePasswordEndpoint: `${BASE_URL}/customer/update-password`,

    //complaint endpoint
    complaintEndpoint: `${BASE_URL}/complaint`,

    //notification endpoint
    notificationEndpoint: `${BASE_URL}/notification`,

    //plan endpoints
    planEndpoint: `${BASE_URL}/plan`,
    publicPlanEndpoint: `${BASE_URL}/plan/public`,

    // storage keys for user (customer) session (separate from staff session)
    storageUserAccessTokenKey: 'userAccessToken',
    storageUserRefreshTokenKey: 'userRefreshToken',
    storageUserInfoKey: 'userInfo',
    storageUserIsLoginKey: 'userIsLogin',
};
